"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusChip = exports.StatusChipContainer = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
exports.StatusChipContainer = Theme_1.styled.div `
  width: ${(props) => props.width || '80px'};
  height: ${(props) => props.height || '24px'};
  border-radius: 16px;
  background-color: ${(props) => props.theme.gray5};
  font-size: 14px;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding-left: 10px;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  div > div {
    height: 10px;
    width: 10px;
    border-radius: 50px;
    margin-right: 3px;
    background: ${(props) => props.theme[props.statusColor] || props.statusColor};
  }

  div > span {
    letter-spacing: 0.15px;
    color: ${(props) => props.theme.gray};
  }
`;
/**
 @deprecated Use Chip Component - leaving this for backwards compatibility
*/
const StatusChip = (props) => {
    return (react_1.default.createElement(exports.StatusChipContainer, Object.assign({}, props),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", null),
            react_1.default.createElement("span", null,
                "\u00A0",
                props.label))));
};
exports.StatusChip = StatusChip;
exports.default = exports.StatusChip;
//# sourceMappingURL=StatusChip.js.map